import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';

import { AuthenticationRoutingModule } from './authentication-routing.module';
import { AuthenticationTokenInterceptor } from './interceptors/authentication-token.interceptor';
import { CallbackPageComponent } from './pages/callback-page/callback-page.component';
import { AuthenticationConfig, IAuthenticationConfig } from './types/authentication-config.types';

@NgModule({
  imports: [AuthenticationRoutingModule, CommonModule, MatCardModule, MatProgressSpinnerModule],
  declarations: [CallbackPageComponent],
})
export class AuthenticationModule {
  static forRoot(config: IAuthenticationConfig): ModuleWithProviders<AuthenticationModule> {
    return {
      ngModule: AuthenticationModule,
      providers: [
        { provide: AuthenticationConfig, useValue: config },
        {
          multi: true,
          provide: HTTP_INTERCEPTORS,
          useClass: AuthenticationTokenInterceptor,
        },
      ],
    };
  }
}
